
<div class="black-inputs" v-loading="loadingPayement">
  <el-row class="texts" v-if="!payementDone && !payementFail && getSelectedResa">
    <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
      Vous allez prélever la caution à<br>
      {{ getClientfullName }}<br>
      d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
      en êtes-vous bien sûr ?<br>
    </el-col>
    <el-col v-else :span="22" :offset="1">
      En validant la réservation, vous allez procéder au prépaiement pour<br>
      {{ getClientfullName }}<br>
      d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
      en êtes-vous bien sûr ?<br>
    </el-col>
  </el-row>
  <el-row class="texts" v-if="payementDone && !payementFail && getSelectedResa">
    <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
      La caution de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
      de {{ getClientfullName }}<br>
      a été encaissé.<br>
    </el-col>
    <el-col v-else :span="22" :offset="1">
      Le prépaiement de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
      de {{ getClientfullName }}<br>
      a été encaissé. <br>
    </el-col>
  </el-row>

  <el-row class="texts" v-if="payementFail && getSelectedResa">
    <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
      Le prélèvement de la caution a échoué pour<br>
      {{ getClientfullName }}<br>
      d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
    </el-col>
    <el-col v-else :span="22" :offset="1">
      L'encaissement du prépaiement de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span
        v-else>{{ Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€ a
      échoué.<br>
      La réservation n'a pas pu être validée correctement.<br>
      Merci de vous rapprocher du client pour voir comment vous allez valider sa réservation :<br>
      {{ getClientfullName }}<br>
      <a :href="'tel:' + this.getClientByid(this.getSelectedResa.cid).tel">{{
        this.getClientByid(this.getSelectedResa.cid).tel }}</a><br>
      <a :href="'mailto:' + this.getClientByid(this.getSelectedResa.cid).email">{{
        this.getClientByid(this.getSelectedResa.cid).email }}</a><br>
      P:<span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
        Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
    </el-col>
  </el-row>

  <el-row class="btns">
    <el-col :span="10" :offset="1" v-if="!payementDone && !payementFail">
      <el-button class="dark" type="primary" @click="closeDialog(true)">Annuler</el-button>
    </el-col>
    <el-col :span="10" :offset="1" v-if="!payementDone && !payementFail">
      <el-button type="primary" @click="procedPayement()">Valider</el-button>
    </el-col>
    <el-col :span="10" :offset="7" v-if="payementDone || payementFail">
      <el-button type="primary" @click="closeDialog()">Ok</el-button>
    </el-col>
  </el-row>
</div>
